export const TypeAngles = {
    "Apto Tipo 9": 120,
    "Apto Tipo 10": 120,
    "Apto Tipo 11": 140,
    "Apto Tipo 12": 50,
    "Apto Tipo 13": 50,
    "Apto Tipo 14": 50,
    "Apto Tipo 15": 80,
    "Apto Tipo 16": 100,
    "Apto Tipo 17": 120,

    "Apto Tipo 27": 50,
    "Apto Tipo 27A": 50,
    "Apto Tipo 28": 80,
    "Apto Tipo 29": 100,
    "Apto Tipo 30": 110,
    "Apto Tipo 31": 120,
    "Apto Tipo 32": 120,
    "Apto Tipo 33": 30,
    "Apto Tipo 34": 40,
    "Apto Tipo 35": 50,
    "Apto Tipo 36": 50,
}